<template>
  <chart-container @onPNGDownload="downloadGraphs(titleChart, 'png', downloadId)" :titleChart="titleChart" @onCSVDownload="downloadGraphs(titleChart, 'csv', downloadId)" @onPDFDownload="downloadGraphs(titleChart, 'pdf', downloadId)" :isZoomEnabled="false" :downloadId="downloadId" :specificSiteId="specificSiteId" :downloadShow="topTimeActivities.length > 0">
    <span class="float-right enrol-tabs" slot="header">
      <b-tabs v-model="tabIndexTopTimeQueries">
        <b-tab v-for="(tabName, index) in tabListTopTimeStatus" :key="index" :title="tabName" />
      </b-tabs>
    </span>

    <table slot="body" class="table table-hover table-borderless mt-10" v-if="topTimeActivities.length > 0">
      <tbody>
        <tr v-for="(item, index) in topTimeActivities" :key="index">
          <td style="width: 5px" class="top-time-activity-text">
            <span class="pdt-5">
              <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#icon_noun_stopwatch)">
                  <path
                    d="M11.7479 3.51203C12.6813 4.39942 13.2184 5.57879 13.2522 6.81528C13.2861 8.05177 12.8141 9.25466 11.9303 10.1844C11.0466 11.1141 9.81586 11.7025 8.4833 11.8323C7.15074 11.9621 5.8141 11.6238 4.73957 10.8848C4.67683 10.8402 4.62424 10.7845 4.5848 10.7211C4.54536 10.6576 4.51984 10.5877 4.5097 10.5151C4.49956 10.4426 4.50499 10.3689 4.5257 10.2983C4.5464 10.2277 4.58197 10.1615 4.63037 10.1036C4.67877 10.0457 4.73905 9.99718 4.80778 9.96077C4.8765 9.92436 4.95232 9.9008 5.03091 9.89144C5.10949 9.88208 5.1893 9.8871 5.26579 9.90621C5.34227 9.92533 5.41393 9.95816 5.47667 10.0028C5.90995 10.3234 6.40894 10.5597 6.94368 10.6977C7.47842 10.8358 8.03787 10.8726 8.58841 10.8059C9.13894 10.7393 9.66922 10.5707 10.1474 10.3101C10.6255 10.0496 11.0417 9.70247 11.3708 9.2897C11.7 8.87693 11.9353 8.407 12.0627 7.90814C12.1902 7.40929 12.207 6.8918 12.1123 6.38677C12.0176 5.88175 11.8133 5.39961 11.5116 4.96931C11.21 4.53902 10.8172 4.16946 10.3569 3.88283C9.81621 3.52734 9.1888 3.30062 8.53037 3.22283C7.99209 3.15623 7.44485 3.18875 6.92026 3.31851C6.39567 3.44827 5.90414 3.6727 5.47407 3.97883C5.34812 4.0671 5.18965 4.10619 5.03279 4.08767C4.87593 4.06915 4.73322 3.99451 4.63539 3.87982C4.53756 3.76513 4.49244 3.61957 4.50973 3.47447C4.52703 3.32937 4.60537 3.19634 4.72787 3.10403C5.49757 2.54989 6.4188 2.20384 7.38897 2.10443V1.45403H6.75327C6.66942 1.45341 6.58663 1.43667 6.51019 1.40485C6.43375 1.37304 6.36533 1.32687 6.30931 1.26928C6.25328 1.21169 6.21088 1.14396 6.1848 1.07039C6.15873 0.996828 6.14956 0.919054 6.15787 0.842034C6.17679 0.701762 6.25126 0.572913 6.36695 0.480302C6.48264 0.387691 6.63136 0.33787 6.78447 0.340434H9.21937C9.30354 0.340403 9.38678 0.356631 9.46375 0.388075C9.54071 0.419519 9.6097 0.465484 9.66626 0.523012C9.72283 0.580541 9.76573 0.648361 9.7922 0.722111C9.81867 0.79586 9.82813 0.873908 9.81997 0.951234C9.80105 1.09151 9.72658 1.22036 9.61089 1.31297C9.4952 1.40558 9.34648 1.4554 9.19337 1.45283H8.58887V2.10323C9.78498 2.22697 10.8995 2.72399 11.7479 3.51203ZM10.2841 5.43203C10.3523 5.35437 10.3869 5.25615 10.3812 5.15633C10.3756 5.0565 10.3301 4.96214 10.2535 4.89145C10.1769 4.82077 10.0747 4.77877 9.96656 4.77355C9.85841 4.76834 9.752 4.80029 9.66787 4.86323L8.13257 6.00203C7.90642 5.97194 7.67574 6.00832 7.47324 6.10603C7.27074 6.20374 7.10671 6.35781 7.00439 6.5464C6.90208 6.73499 6.86667 6.94852 6.9032 7.15672C6.93973 7.36493 7.04633 7.55723 7.2079 7.70637C7.36947 7.85551 7.5778 7.95392 7.80336 7.98764C8.02891 8.02136 8.26024 7.98868 8.46454 7.89423C8.66885 7.79978 8.83576 7.64837 8.94161 7.46145C9.04746 7.27453 9.08688 7.06159 9.05427 6.85283L10.288 5.43203H10.2841ZM5.05547 5.76203C5.19338 5.76203 5.32565 5.71146 5.42317 5.62145C5.52069 5.53143 5.57547 5.40934 5.57547 5.28203C5.57547 5.15473 5.52069 5.03264 5.42317 4.94262C5.32565 4.85261 5.19338 4.80203 5.05547 4.80203H1.08787C0.949958 4.80203 0.817694 4.85261 0.720176 4.94262C0.622657 5.03264 0.567871 5.15473 0.567871 5.28203C0.567871 5.40934 0.622657 5.53143 0.720176 5.62145C0.817694 5.71146 0.949958 5.76203 1.08787 5.76203H5.05547ZM5.05547 6.51203H2.06547C1.92756 6.51203 1.79529 6.56261 1.69778 6.65262C1.60026 6.74264 1.54547 6.86473 1.54547 6.99203C1.54547 7.11934 1.60026 7.24143 1.69778 7.33145C1.79529 7.42146 1.92756 7.47203 2.06547 7.47203H5.05547C5.19338 7.47203 5.32565 7.42146 5.42317 7.33145C5.52069 7.24143 5.57547 7.11934 5.57547 6.99203C5.57547 6.86473 5.52069 6.74264 5.42317 6.65262C5.32565 6.56261 5.19338 6.51203 5.05547 6.51203ZM5.57547 8.69723C5.57547 8.56993 5.52069 8.44784 5.42317 8.35782C5.32565 8.26781 5.19338 8.21723 5.05547 8.21723H2.87537C2.73746 8.21723 2.60519 8.26781 2.50768 8.35782C2.41016 8.44784 2.35537 8.56993 2.35537 8.69723C2.35537 8.82454 2.41016 8.94663 2.50768 9.03665C2.60519 9.12666 2.73746 9.17723 2.87537 9.17723H5.05547C5.12376 9.17692 5.19131 9.16419 5.25427 9.13978C5.31723 9.11537 5.37436 9.07975 5.42241 9.03495C5.47045 8.99016 5.50847 8.93706 5.53429 8.87871C5.5601 8.82035 5.57321 8.75787 5.57287 8.69483L5.57547 8.69723Z"
                    :fill="primaryColor"
                  />
                </g>
                <defs>
                  <clipPath id="icon_noun_stopwatch">
                    <rect width="15" height="14" fill="white" transform="translate(0.437988 0.122147)" />
                  </clipPath>
                </defs>
              </svg>
            </span>
          </td>
          <td style="width: 5px" class="top-time-activity-text-padding-right">
            <span class="top-time-activity-text-number">{{ index + 1 }}</span>
          </td>
          <td style="text-align: left" class="top-time-activity-text">
            {{ item.label }}
          </td>
          <td style="text-align: right;width:80px" class="top-time-activity-text">
            <span>{{ item.value }} {{ item.value != 1 ? "days" : "day&nbsp;&nbsp;" }}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-else class="align-center p-60" slot="body">
      <div class="card-text-title no-data" v-if="dataLoaded">No Data In</div>
    </div>
  </chart-container>
</template>

<script>
import jspdf from "jspdf";
import html2canvas from "html2canvas";
import { downloadCSV, getSiteID } from "../../services/visualization/data-management";
import moment from "moment";
import ChartContainer from "@/components/containers/chart-container";
import * as dManagement from "@/services/visualization/new-data-management";

export default {
  components: { ChartContainer },
  props: {
    activitiesRaw: { type: [Object, Array], default: () => [] },
    tabListTopTimeStatus: { type: Array, default: () => [] },
    titleChart: { type: String, default: "" },
    subtitleChart: { type: String, default: "" },
    sitesSelected: { type: Array, default: () => ["all"] },
    countrySelected: { default: () => "all" },
    downloadId: { type: String, default: "" },
    specificSiteId: { type: Array, default: () => {} },
    dataLoaded: { type: Boolean, default: false },
    filterTriggered: { type: Boolean, default: false }
  },
  data() {
    return {
      topTimeActivities: [],
      tabIndexTopTimeQueries: 0,
      primaryColor: "#000",
      containerId: "top-five-longest-status",
      todayDate: "",
      tDateShow: true,
      getSiteID
    };
  },
  methods: {
    downloadGraphs(titleChart, type, downloadId) {
      this.todayDate = moment()
        .format("DD MMM YYYY hh:mm:ss")
        .toUpperCase();
      this.tDateShow = false;

      setTimeout(() => {
        switch (type) {
          case "csv":
            const csvHeaders = this.generateCsvHeaders(this.tabIndexTopTimeQueries);
            this.tDateShow = true;
            const csvContent = [];

            this.topTimeActivities.map(item => csvContent.push([item.label, item.value]));
            downloadCSV(titleChart, csvHeaders, csvContent, this.specificSiteId);
            break;
          case "pdf":
            let filename = titleChart + "_" + this.todayDate + ".pdf";
            if (this.specificSiteId && this.specificSiteId.length > 0) {
              filename = titleChart + "_" + this.todayDate + "_" + getSiteID(this.specificSiteId[0]) + ".pdf";
            }
            let container = document.querySelector("#" + downloadId);
            this.tDateShow = true;
            html2canvas(container, {
              allowTaint: true,
              logging: false,
              scrollY: -window.scrollY,
              scrollX: -window.scrollX - 6,
              onclone: function(document) {
                document.querySelectorAll(".nav-item").forEach(element => {
                  const ele = element.querySelector(".nav-link.active");
                  if (!ele) {
                    element.remove();
                  }
                });
              }
            }).then(canvas => {
              const imgData = canvas.toDataURL("image/png");
              const pdf = new jspdf("p", "mm", "a4");
              const imgProps = pdf.getImageProperties(imgData);
              const pdfWidth = pdf.internal.pageSize.getWidth();
              const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

              pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
              pdf.save(filename);
            });
            break;
          case "png":
            if (this.specificSiteId && this.specificSiteId.length > 0) {
              filename = titleChart + "_" + this.todayDate + "_" + getSiteID(this.specificSiteId[0]) + ".png";
            }
            this.tDateShow = true;
            html2canvas(container, {
              allowTaint: true,
              logging: false,
              scrollY: -window.scrollY,
              scrollX: -window.scrollX - 6,
              onclone: function(document) {
                document.querySelectorAll(".nav-item").forEach(element => {
                  const ele = element.querySelector(".nav-link.active");
                  if (!ele) {
                    element.remove();
                  }
                });
              }
            }).then(function(canvas) {
              const link = document.createElement("a");
              document.body.appendChild(link);
              link.download = filename;
              link.href = canvas.toDataURL("image/png");
              link.target = "_blank";
              link.click();
            });
            break;
          default:
            break;
        }
      }, 1);
    },
    generateCsvHeaders(tabIndex) {
      const headers = ["Activity Name"];
      switch (tabIndex) {
        case 0:
          headers.push("Entry Completed (in days)");
          break;
        case 1:
          headers.push("Approved (in days)");
          break;
        case 2:
          headers.push("Verified (in days)");
          break;
        case 3:
          headers.push("Signed Off (in days)");
          break;
        default:
          break;
      }

      return headers;
    }
  },
  watch: {
    activitiesRaw: function(newValue) {
      this.topTimeActivities = newValue ? dManagement.GET_TOP_TIME_ACTIVITIES(newValue, this.countrySelected, this.sitesSelected, this.tabIndexTopTimeQueries) : [];
    },
    filterTriggered: function() {
      const topTimeActivities = dManagement.GET_TOP_TIME_ACTIVITIES(this.activitiesRaw, this.countrySelected, this.sitesSelected, this.tabIndexTopTimeQueries);
      this.topTimeActivities = topTimeActivities;
    },
    tabIndexTopTimeQueries: function(newValue) {
      const topTimeActivities = dManagement.GET_TOP_TIME_ACTIVITIES(this.activitiesRaw, this.countrySelected, this.sitesSelected, newValue);
      this.topTimeActivities = topTimeActivities;
      this.tabIndexTopTimeQueries = newValue;
    },
    topTimeActivities: function(newValue) {
      this.topTimeActivities = newValue;
      const primaryColor = document.querySelector(":root").style.getPropertyValue("--study-primary-color");
      this.primaryColor = primaryColor || "#7f69d4";
    }
  },
  mounted() {
    const primaryColor = document.querySelector(":root").style.getPropertyValue("--study-primary-color");
    this.primaryColor = primaryColor || "#00C3B3";
  }
};
</script>
<style lang="scss" scoped>
.pdt-5 {
  margin-right: 2.2px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 23px;
}

.full-width-100 {
  width: 100%;
}
</style>
